export const environment = {
  production: false,
  url: "",
};
